import Fuse from 'fuse.js';
import { Task } from '../types';
import { getFilteredTasks, onFilteredTasksChange } from './';

const fuse = new Fuse<Task>(getFilteredTasks(), {
  keys: ['id', 'title'],
  includeScore: true,
  threshold: 0.5,
});

onFilteredTasksChange((tasks) => {
  fuse.setCollection(tasks);
});

export function search(query: string) {
  return fuse.search(query);
}
